export default __webpack_public_path__ + "static/media/can2.cb41c3b3.jpeg";